import { getServerVersion } from '@/api'
import styled from '@emotion/styled'
import { useEffect, useState } from 'react'

const VersionInfoBase = (props) => {
  const [serVer, setSerVer] = useState('version')
  useEffect(() => {
    getServerVersion()
      .then(setSerVer)
      .catch(() => setSerVer('unknown'))
  }, [])
  return <div {...props} title={'JS build ' + __BUILD_DATE__}>{serVer}</div>
}

const VersionInfo = styled(VersionInfoBase)`
  font-size: 0.7rem;
  text-align: center;
  width: 100%;
  overflow: visible;
  z-index: 100;
  color: #8888;
  margin: 0;
`

export default VersionInfo